/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-18 20:29:52
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-09-15 14:45:42
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/components/mySchedules/index.tsx
 * @Description: 我的日程列表
 */
import React, { useMemo, useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { Button } from '@tencent/tpm-meeting-active/lib';
import '@tencent/tpm-meeting-active/lib/MySchedule/style';
import Header from '@tencent/tpm-meeting-active/lib/Header';
import '@tencent/tpm-meeting-active/lib/Header/style';
import ArrowbottomLineIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/ArrowbottomLineIcon';
import { OwnSchedules } from '@quickService/ActivitiesRegisterQueryUserSchedule';
import { SchedulerDataList } from '@quickService/PublicRegistrationQueryEventSchedulers';
import { getBetweenDate } from '@utils/parse-date';
import ScheduleBtn from '../scheduleBtn/index';
import showScheduelModal from '../scheduleDetail';
import { useEventID } from '@hooks/useEventId';
import { AppContext } from '@utils/browser/app-context';
import dataReport from '@utils/data-report';
import './index.scss';
interface MyScheduleListProps {
  scheduleList?: OwnSchedules;
  isMobile?: boolean;
  eventId?: string;
  allScheduleList?: SchedulerDataList;
  activityUrl?: string;
  /** 关掉展开更多 */
  hideCollapse?: boolean;
  /** 是否为canvas报名页 */
  isCanvasPage?: boolean;
}
interface MyScheduleProps {
  className: string;
  title: string;
  date: string;
  status: string;
  guestflag: boolean;
  onClick: () => void;
  opers: React.ReactNode;
  active?: boolean;
}
/*
 * 我的日程 组件
 */
function MySchedule(props: MyScheduleProps) {
  return (
    <div className={classNames('ma-my-schedule', props.className)}>
      <div className="ma-my-schedule__main">
        <div className="ma-my-schedule__tit" title={props.title}>
          {props.status && (
            <span className={classNames('ma-my-schedule__status', props.status)}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          )}
          {props.title}
        </div>
        <div className="ma-my-schedule__date ma-my-schedule__info">
          <div>{props.date}</div>
          {props.guestflag && <div className="ma-my-schedule__guestflag">嘉宾</div>}
        </div>
      </div>
      <div className="ma-my-schedule__opers">
        <div className="line">{props.opers}</div>
        <div className="line">
          {props.guestflag && <div className="ma-my-schedule__guestflag">嘉宾</div>}
        </div>
      </div>
      {props.active && <div className="ma-my-schedule-active" />}
    </div>
  );
}
const ScheduleItem = ({
  schedule,
  allScheduleList,
  activityUrl,
  active,
  isCanvasPage,
}: {
  schedule: OwnSchedules[0];
  allScheduleList?: SchedulerDataList;
  activityUrl?: string;
  active?: boolean;
  isCanvasPage?: boolean;
}) => {
  const { eventId } = useEventID();

  const [dateTime, status, isGuest] = useMemo(() => {
    const { begin_time: beginTime = 0, end_time: endTime = 0, user_type: userType } = schedule;

    const date = getBetweenDate(beginTime, endTime);
    const nowTime = Date.now() / 1000;
    const isStart = nowTime > beginTime && nowTime < endTime;
    return [date, isStart ? 'start' : '', userType === 'guest'];
  }, [schedule]);

  const showSchedule = useMemo(() => {
    if (allScheduleList) {
      return allScheduleList.find((item) => item.scheduler_id === schedule.schedule_id);
    }
    return undefined;
  }, []);

  const showScheduleModal = () => {
    if (showSchedule && activityUrl) {
      showScheduelModal(showSchedule, activityUrl, eventId);
    }
  };

  // 移动端我的日程 和 PC 我的日程 公共样式
  return (
    <MySchedule
      className="my-schedule-custom"
      title={schedule.schedule_name!}
      date={dateTime}
      status={status}
      guestflag={isGuest}
      onClick={showScheduleModal}
      opers={<ScheduleBtn {...schedule} isCanvasPage={isCanvasPage} />}
      active={active}
    />
  );
};

const MyScheduleList = ({
  scheduleList,
  eventId,
  isMobile,
  allScheduleList,
  activityUrl,
  hideCollapse,
  isCanvasPage,
}: MyScheduleListProps) => {
  const [showAll, setShowAll] = useState(false);
  const [splash, setSplash] = useState(false);
  const { userData } = useContext(AppContext);
  const list = useMemo(() => {
    if (showAll || hideCollapse) {
      return scheduleList;
    }
    return scheduleList?.slice(0, 3);
  }, [scheduleList, showAll, hideCollapse]);

  const hasMore = scheduleList && scheduleList.length > 3 && !hideCollapse;

  const handleShow = () => {
    setShowAll(!showAll);
    dataReport('e#event_registrationpage#all_schedule_button#click', {
      activity_id: eventId,
    });
  };

  useEffect(() => {
    // @ts-ignore
    if (userData.goToTickets) {
      setTimeout(() => {
        setSplash(true);
      }, 600);

      return;
    }

    setSplash(false);
  }, [userData]);

  return (
    <>
      {isMobile && <Header className="small-header" title="我的日程" />}
      {list?.map((item, index) => (
        <ScheduleItem
          key={item.schedule_id}
          schedule={item}
          allScheduleList={allScheduleList}
          activityUrl={activityUrl}
          active={splash && index === 0}
          isCanvasPage={isCanvasPage}
        />
      ))}
      {hasMore && (
        <div className="schedule-list">
          {isMobile ? (
            <Button type="link" onClick={handleShow} className={classNames({ up: showAll })}>
              {showAll ? '收起' : '查看更多'}
              <ArrowbottomLineIcon />
            </Button>
          ) : (
            <Button onClick={handleShow} className="registration-more-schedule">
              {showAll ? '收起日程' : '展开更多日程'}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default MyScheduleList;
